import axios from "axios";
import { API_URL } from "../../consts";

// Shared helper: strict status validation for all chat API calls.
function assertOk(response, errorMessage) {
  if (!response || response.status !== 200) {
    throw new Error(errorMessage);
  }
  return response.data;
}

export async function getAllChats() {
  const response = await axios.get(`${API_URL}/chats`);
  return assertOk(response, "Failed to fetch chats");
}

export async function getChatById(chatId) {
  const response = await axios.get(`${API_URL}/chats/${chatId}`);
  return assertOk(response, "Failed to fetch chat details");
}

// options.signal: optional AbortSignal so in-flight requests can be
// cancelled on chat switch / close / unmount.
export async function postAIRequest(payload, options = {}) {
  const response = await axios.post(`${API_URL}/chats/ai`, payload, {
    signal: options.signal,
  });
  return assertOk(response, "Failed to post AI request");
}

export async function updateSpaceRecommendations(spaceIds, enableRecommendations) {
  const response = await axios.put(`${API_URL}/spaces/recommendations`, {
    space_ids: spaceIds,
    search_for_recommendations: enableRecommendations,
  });
  return assertOk(response, "Failed to update space recommendations");
}

export async function getTaskStatus(taskId) {
  // SECURITY: Token is in httpOnly cookies, axios interceptor handles it
  const response = await axios.get(`${API_URL}/chats/task/${taskId}`);
  return assertOk(response, "Failed to fetch task status");
}

export async function cancelTask(taskId) {
  // SECURITY: Token is in httpOnly cookies, axios interceptor handles it
  const response = await axios.delete(`${API_URL}/chats/task/${taskId}`);
  return assertOk(response, "Failed to cancel task");
}

export async function deleteChatApi(chatId) {
  const response = await axios.delete(`${API_URL}/chats/${chatId}`);
  return assertOk(response, "Failed to delete chat");
}

export async function renameChatApi(chatId, name) {
  const response = await axios.patch(`${API_URL}/chats/${chatId}`, { name });
  return assertOk(response, "Failed to rename chat");
}

// True when the request failed because it was intentionally aborted
// (AbortController) rather than a real error. Works across axios versions.
export function isRequestCancelled(error) {
  return Boolean(
    error &&
      (axios.isCancel?.(error) ||
        error.name === "CanceledError" ||
        error.code === "ERR_CANCELED" ||
        error.message === "canceled")
  );
}
